<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <ul class="unstyled-list ui-topnav">
          <li v-for="(bot, index) in botones" :key="'toplist'+index" class="animated rotateIn">
            <button class="circ-topnav hvr-grow" :id="'bot-slide-'+index" :aria-label="'Botón '+ (index+1) + (bot.visto?' Visto':' No visto')" @click="botClick(index)" :class="(contenido === (index+1)?'topnav-active':'') + ' ' + ('dura_'+index)">{{index+1}}</button>
            <div class="checkBot">
              <image-app v-if="bot.visto" class="animated bounceIn" :imaSize="20" imaSrc="logos-icons/ok-bullet" imaAlt=""></image-app>
            </div>
          </li>
        </ul>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 sm10 mt-3>
        <div tabindex="0" id="contenidos" :aria-label="'Contenido boton ' + contenido" class="unstyled-focus"></div>
        <div v-for="(item, index) in botones" :key="'slide-cont'+index" v-if="contenido === (index+1)">
          <slot :name="'cont-'+index"></slot>
        </div>
        <button v-if="!finContenidos" @click="backMenu()" aria-label="Volver a la lista anterior"></button>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  props: {
    cantidadItems: {
      type: Number,
      requiere: true
    }
  },
  data() {
    return {
      finContenidos: false,
      contenido: 0
    };
  },
  methods: {
    botClick(event) {
      this.contenido = event + 1;
      this.botones[event].visto = true;
      document.getElementById("contenidos").focus();

      var showNext = this.botones.every(elem => {
        return elem.visto === true;
      });
      if (showNext) {
        this.$store.commit("nextShow", true);
      }
      this.finContenidos = showNext;
    },
    backMenu() {
      document.getElementById("bot-slide-" + this.contenido).focus();
    }
  },
  computed: {
    botones() {
      var arrayBots = [];
      for (let index = 0; index < this.cantidadItems; index++) {
        arrayBots.push({
          visto: false
        });
      }
      return arrayBots;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../sass/helpers/variables";
@import "../../sass/helpers/mixins";

.ui-topnav {
  text-align: center;
  width: 100%;
  li {
    display: inline-block;
    vertical-align: top;
    position: relative;
    .checkBot {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

.circ-topnav {
  background-color: #ccc;
  width: 50px;
  height: 50px;
  margin: 5px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 1.7rem;
  &.topnav-active {
    background-color: $secondary-red;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// TopNavigation.vue?ff823cb6